import accounts from "./accounts";
import activities from "./activities";
import analysis from "./analysis";
import appointments from "./appointments";
import auth from "./auth";
import automations from "./automations";
import billing from "./billing";
import buyingOffers from "./buyingOffers";
import calendarIntegrations from "./calendarIntegrations";
import callRailIntegrations from "./callRailIntegrations";
import callScripts from "./callScripts";
import callScriptSteps from "./callScriptSteps";
import campaign_costs from "./campaign_costs";
import campaigns from "./campaigns";
import campaignUnitCount from "./campaignUnitCount";
import clientStore from "./clientStore";
import communicationLogs from "./communicationLogs";
import contacts from "./contacts";
import contactTypes from "./contactTypes";
import custom from "./custom";
import customFields from "./customFields";
import download from "./download";
import exports from "./exports";
import fieldMaps from "./fieldMaps";
import fixAndFlipSellingInfos from "./fixAndFlipSellingInfos";
import followUp from "./followUp";
import fusStepTemplates from "./fusStepTemplates";
import fusTemplates from "./fusTemplates";
import googleIntegrations from "./googleIntegrations";
import help from "./help";
import imports from "./imports";
import integrationPhoneNumbers from "./integrationPhoneNumbers";
import integrations from "./integrations";
import markets from "./markets";
import notes from "./notes";
import notifications from "./notifications";
import pipeline from "./pipeline";
import pipelineViews from "./pipelineViews";
import properties from "./properties";
import records from "./records";
import scheduledContacts from "./scheduledContacts";
import snippets from "./snippets";
import stats from "./stats";
import statuses from "./statuses";
import tags from "./tags";
import tasks from "./tasks";
import taskTemplates from "./taskTemplates";
import userInvites from "./userInvites";
import users from "./users";
import webhooks from "./webhooks";
import wholesaleSellingInfos from "./wholesaleSellingInfos";
import zillow from "./zillow";
import contactContactType from "./contactContactType";
import onboarding from "./onboarding";
import shareableGroups from "./shareableGroups";
import shareableGroupEmails from "./shareableGroupEmails";
import signalWire from "./signalWire";
import smrtPhone from "./smrtPhone";
import answeringSequences from "./answeringSequences";
import answeringSequenceSteps from "./answeringSequenceSteps";
import recordings from "./recordings";
import twilio from "./twilio";
import launchControl from "./launchControl";
import phoneAgents from "./phoneAgents";
import pusher from "./pusher";
import cancelAccount from "./cancelAccount";
import supportServices from "./supportServices";
import leadsTable from "./leadsTable"
import tableConfiguration from "./tableConfiguration";
import statsTeam from "./statsTeam";
import taskLists from "./taskLists";
import customerMessages from "./customerMessages";
import campaignCostTemplate from "./campaignCostTemplate";
import sellingInfos from "./sellingInfos";
/** Auto Import */

const api = {
    accounts: accounts,
    activities: activities,
    analysis: analysis,
    appointments: appointments,
    auth: auth,
    automations: automations,
    billing: billing,
    buyingOffers: buyingOffers,
    calendarIntegrations: calendarIntegrations,
    callRailIntegrations: callRailIntegrations,
    callScripts: callScripts,
    callScriptSteps: callScriptSteps,
    campaign_costs: campaign_costs,
    campaigns: campaigns,
    campaignCostTemplate: campaignCostTemplate,
    campaignUnitCount: campaignUnitCount,
    cancelAccount: cancelAccount,
    clientStore: clientStore,
    communicationLogs: communicationLogs,
    contacts: contacts,
    contactTypes: contactTypes,
    custom: custom,
    customFields: customFields,
    download: download,
    exports: exports,
    fieldMaps: fieldMaps,
    fixAndFlipSellingInfos: fixAndFlipSellingInfos,
    followUp: followUp,
    fusStepTemplates: fusStepTemplates,
    fusTemplates: fusTemplates,
    googleIntegrations: googleIntegrations,
    help: help,
    imports: imports,
    integrationPhoneNumbers: integrationPhoneNumbers,
    integrations: integrations,
    launchControl: launchControl,
    markets: markets,
    notes: notes,
    notifications: notifications,
    pipeline: pipeline,
    pipelineViews: pipelineViews,
    properties: properties,
    records: records,
    scheduledContacts: scheduledContacts,
    snippets: snippets,
    stats: stats,
    statuses: statuses,
    supportServices: supportServices,
    tags: tags,
    tasks: tasks,
    taskTemplates: taskTemplates,
    taskLists: taskLists,
    userInvites: userInvites,
    users: users,
    webhooks: webhooks,
    wholesaleSellingInfos: wholesaleSellingInfos,
    zillow: zillow,
    contactContactType: contactContactType,
    onboarding: onboarding,
    sellingInfos: sellingInfos,
    shareableGroups: shareableGroups,
    shareableGroupEmails: shareableGroupEmails,
    signalWire: signalWire,
    smrtPhone: smrtPhone,
    twilio: twilio,
    answeringSequences: answeringSequences,
    answeringSequenceSteps: answeringSequenceSteps,
    recordings: recordings,
    phoneAgents: phoneAgents,
    pusher: pusher,
    leadsTable: leadsTable,
    tableConfiguration: tableConfiguration,
    statsTeam: statsTeam,
    customerMessages: customerMessages
    /** Auto Register */
};

export default api;
